export const extractFilenameFromHeader = (contentDisposition) => {
    const match = contentDisposition && contentDisposition.match(/filename="(.+)"/);
    return match ? match[1] : null;
};


export const useDownloadHandler = (serviceMethod, setLoading) => {
    return async (e, params) => {
        e.preventDefault();

        setLoading(true);

        try {
            const response = await serviceMethod(...params);

            const contentDisposition = response.headers['content-disposition'];
            const filename = extractFilenameFromHeader(contentDisposition) || 'default-filename.xlsx';

            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            setLoading(false);
        } catch (error) {
            console.error('Error triggering download:', error);
            setLoading(false);
        }
    };
};
